import { Routes, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import sanga3 from "../../assets/camb (4).jpg"
import Aos from 'aos';
import 'aos/dist/aos.css'
import { useEffect, useState } from "react";
import axios from 'axios';
import kid3 from "../../assets/kid (1).jpg"
import kid4 from "../../assets/kid (2).jpg"
import kid5 from "../../assets/kid (3).jpg"

import kid from "../../assets/kids (1).jpg"
import kid2 from "../../assets/kids (3).jpg"


import { useTranslation } from "react-i18next";

import { API_URL } from "../../config";

function KidsCourses() {


  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const { t } = useTranslation();
  const images = [kid, kid2, kid3, kid4, kid5
  ];

  useEffect(() => {
    Aos.init({ duration: 2000 });
  });

  const [formData, setFormData] = useState({
    firstname: "",
    phone: "",
    age: "",
    stars: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.firstname.trim() || !formData.phone.trim() || !formData.age.trim() || !formData.stars.trim()) {
      alert("فضلاً املئي كل الحقول");
      return;
    }

    try {
      await axios.post(`${API_URL}/kidsCourses`, formData);
      alert('تم التسجيل بنجاح ✅');
      setFormData({ firstname: "", phone: "", age: "", stars: "" });
    }
    catch (err) {
      console.log(err);
      alert("حدث خطأ: " + (err.response?.data?.error || err.message));
    }
  };
  return (

    <div>

      <div className="w-full h-full relative" >

        <img src={kid5} className="hidden lg:block w-full h-full object-cover" />

        <div className='lg:absolute gap-6  inset-0 bg-black/40 flex  flex-col items-center justify-center lg:flex-row'>

          <img src={kid5} className="lg:hidden w-full h-full absolute  top-0 object-cover" />

          <div data-aos="fade-right"
            className=" lg:relative  flex items-center flex-col rtl h-full p-4 lg:m-6 justify-center" dir={i18n.language === "ar" ? "rtl" : "ltr"}>
            <h1 className="text-white  text-4xl md:text-8xl font-bold">{t("kid")} </h1>
            <h3 className="text-white   md:text-xl font-bold p-4"> {t("go")}</h3>
          </div>

          <form onSubmit={handleSubmit} data-aos="fade-left"
            className=" mx-4 rounded-[20px] md:w-[500px] w-full
  mx-w-md mx-auto mt-10 p-4  items-center 
 justify-center mb-0 bg-blue-400/50 text-white" >
            <div className="space-y-12">
              <div className="border-b border-gray-900/10 pb-12">
                <h2 className="text-base/7 font-semibold text-white justify-center">{t("kidform")}</h2>
                <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                  <div className="sm:col-span-4">
                    <label for="first-name" className="block text-sm/6 font-medium ">{t("name")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} type='text' value={formData.firstname} id="first-name" name="firstname" autocomplete="given-name" className="block bg-blue-100/50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6" />
                    </div>
                  </div>

                  <div className="sm:col-span-4">
                    <label for="email" className="block text-sm/6 font-medium ">{t("phone")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} id="email" type="tel" value={formData.phone} name="phone" autocomplete="phone" className="block border  w-full rounded-md bg-blue-100/50 px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300sm:text-sm/6" />
                    </div>
                  </div>


                  <div className="sm:col-span-4">
                    <label for="email" className="block text-sm/6 font-medium ">{t("dive")}</label>
                    <div className="mt-2">
                      <select value={formData.stars} onChange={handleChange} name="stars" className="block border  w-full rounded-md  px-3 py-1.5 text-base bg-blue-100/50  text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6">
                        <option value="">{t("courseStars")}</option>
                        <option value="One Star">{t("oneStar")}</option>
                        <option value="Tow Stars">{t("twoStars")}</option>
                      </select>
                    </div>
                  </div>

                  <div className="sm:col-span-4">
                    <label for="email" className="block text-sm/6 font-medium ">{t("age")}</label>
                    <div className="mt-2">
                      <select value={formData.age} onChange={handleChange} name="age" className="block border  w-full rounded-md  px-3 py-1.5 text-base bg-blue-100/50  text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6">
                        <option value="">{t("age")}</option>
                        <option value="5 - 10">5 - 10</option>
                        <option value="10 - 14">10 - 13</option>

                      </select>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="mt-6 flex items-center justify-end gap-x-6">

              <button type="submit" className="rounded-md w-full bg-blue-400 px-3 py-2 text-sm font-semibold 
    text-white shadow-xs hover:bg-blue-500 focus-visible:outline-2 focus-visible:outline-offset-2
     focus-visible:outline-blue-600">{t("send")}</button>
            </div>
          </form>


        </div>
      </div>


      <div className='w-full  my-10  rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>{t("dgalary")}</h1></center>
        <div data-aos="fade-up" className=' max-w-6xl mx-auto  md:columns-3 gap-8 sm:columns-2 columns-1 '>

          {images.map((image, index) => (
            <img src={image} className='rounded-lg shadow-xl w-auto transition-transform duration-500 ease-in-out
 hover:scale-110 mb-4 '/>
          ))}
        </div></div>

    </div>
  );
}
export default KidsCourses;